<template>
  <div>
    <Pane />
    <Allocate :visible="allocateVisible" :id="detail.project.id" :ifSync="ifSync" :allocateOver="allocateOver" :amount="detail.amount/10000" :finId="finId" :type="type" :filteredList1="progressList" :filteredList2="allocateList" @setVisible="allocateVisible=false" @success="saveSuccess"/>

    <a-card class="container">

      <div class="card-header">
        <div class="card-title">收支概况</div>
      </div>

      <a-descriptions bordered :column="2" size='small'>
        <a-descriptions-item>
          <div slot="label" class="center">项目名称</div>
          <div>
            {{ detail.project.name }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">经办人</div>
          <div>
            {{ detail.handlerUserName }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">选择分包</div>
          <div>
            {{ subProject }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">分包公司</div>
          <div>
            {{ detail.companyName }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">发生金额(万)</div>
          <div style="color: #1890ff">
            <Money :money="detail.amount" />
          </div>
        </a-descriptions-item>


        <a-descriptions-item>
          <div slot="label" class="center">发生日期</div>
          <div>
            {{ detail.date }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">所属月份</div>
          <div>
            {{ detail.belongMonth }}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">收支类型</div>
          <div>
            <DataDictFinder dictType="project_fin_type" :dictValue="detail.type" />
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">是否扣除产值</div>
          <div>
            {{detail.isDeductOutputValue}}
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">备注</div>
          <div>
            {{detail.remark}}
          </div>
        </a-descriptions-item>
      </a-descriptions>

      <div class="card-header">
        <div class="card-title">分配详情</div>
        <a-button type="primary" style="margin-left: 20px;" @click="allocate(detail)">分配</a-button>
      </div>
      <a-table bordered :data-source="detail.deptList" :loading="loading" :pagination="false">
        <a-table-column title="部门" data-index='deptName' />
        <a-table-column title="专业">
          <template slot-scope="text">
            <DataDictFinder dictType="majorTypes" :dictValue="text.deptMajor" />
          </template>
        </a-table-column>
        <a-table-column title="部门占比">
          <template slot-scope="text">
            {{ text.prop }}%
          </template>
        </a-table-column>
        <a-table-column title="金额(万元)">
          <template slot-scope="text">
            <Money :money="text.amount" />
          </template>
        </a-table-column>
      </a-table>
      <div class="center" style="margin-top: 40px;">
        <a-space>
          <a-button @click="$close($route.path)">关闭</a-button>
        </a-space>
      </div>
    </a-card>
  </div>
</template>



<script>
import { fetchDetail as fetchDetailSub } from "@/api/project";
import request from '@/api/request'
import Allocate from './components/allocate.vue'
import CompanySelector from "@/components/company-selector";
function fetchDetail(id) {
  return request({
      url:  '/project-service/projectFin/detail2/' +id,
      method: 'post',
  })
}
function add(data) {
  return request({
      url:  '/project-service/projectFin/add',
      method: 'post',
      data,
  })
}

function remove(id) {
  return request({
      url:  '/project-service/projectFin/del/' +id,
      method: 'post',
  })
}

export default {

  name: 'projectFin_detail',
  components:{
    Allocate,
    CompanySelector
  },
  data() {
      return {
          subProject: null,
          allocateVisible: false,
          visible: false,
          loading: false,
          detail: {
            project: {},
          },
          bidList: [],
          bidBudgetList: [],

          saveLoading: false,
          finList: [],
          incomeDeptSum: [],
          expendDeptSum: [],
          type: '',
          filteredList: [],
          allProgressList: [],
          progressList: [],
          allocateList: [],
          finId: '',
          amount: 0,
          allocateOver: 0,
          ifSync: false,
          selectedProject: {
            name: ''
          }
      }
  },

  computed: {
    
  },

  mounted() {
      this.getList();
  },


  methods: {
    getList(){
      const { id } = this.$route.query;
      this.loading = true;
      fetchDetail(id).then(res => {
        if (res) {
          this.detail = res;
          this.finList = res.finList || []
          this.incomeDeptSum = res.incomeDeptSum || []
          this.expendDeptSum = res.expendDeptSum || []
          this.allProgressList = res.projectProgressList;
          fetchDetailSub(res.project).then(res => {
            if (res) {
              this.subProject = res.subPackages.filter(item => item.id === this.detail.companyId)[0].name;
            }
          })
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    leiJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i && item.type == 'income') {
          amount += item.amount;
        }
      });
      return amount
    },
    leiJiYuJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i) {
          amount += (this.detail.subSum / this.detail.projectAmount * item.amount);
        }
      });
      return amount.toFixed(6)
    },
    leiJiShiJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i && item.type == 'expend') {
          amount += item.amount;
        }
      });
      return amount
    },
    addIncome() {
      this.visible = true;
      this.type = 'income';
      this.filteredList = [];
    },
    addExpend() {
      this.visible = true;
      this.type = 'expend';
      this.filteredList = [];
    },
    handleAdd() {
        const newData = {
          editable: true,
          belongMonth: null,
          date: null,
          amount: null
        };
        this.filteredList.push(newData)
      },
    handleSave(text, index) {
      this.filteredList.splice(index, 1, {
        belongMonth: text.belongMonth ? text.belongMonth.format("YYYY-MM") : null,
        date: text.date ? text.date.format("YYYY-MM-DD") : null,
        amount: text.amount,
        editable: false
      })
    },  
    handleDelete(text,index) {
      this.filteredList.splice(index, 1)
    },
    handleSubmit() {
      const { id } = this.$route.query;
      this.filteredList = this.filteredList.map(v=>{
        return {
          ...v,
          type: this.type,
          projectId: id,
          belongMonth: v.belongMonth ? v.belongMonth.format("YYYY-MM") : null,
          date: v.date ? v.date.format("YYYY-MM-DD") : null,
        }
      })
      add(this.filteredList).then(()=>{
        console.log(111)
        this.visible = false;
        this.getList();
      })
    },
    allocate(row){
      this.allocateVisible = true;
      this.type = row.type;
      this.finId = row.id;
      this.amount = row.amount;
      this.allocateOver = row.allocateOver;
      this.allocateList = JSON.parse(JSON.stringify(row.deptList));
      this.ifSync= row.ifSync ? true:false;
    },
    removeA(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove(text.id).then(() => {
            that.getList();
          });
        }
      });
    },
    saveSuccess() {
      this.allocateVisible = false;
      this.getList();
    }
  }
}
</script>

<style lang="less" scoped>
.container {
background-color: #fff;
padding: 24px 160px;
}

.card-header {
margin-top: 16px;
margin-bottom: 8px;
display: flex;
align-items: center;
justify-content: space-between;

.card-title {
font-weight: bold;
font-size: 14px;
color: #1890ff;
}


}
.sub-header{
  margin: 20px 5px 5px 5px;
}
</style>